(function () {
  'use strict';

  var TRUE_FETCH = (window.__qoubraTrueFetch || window.fetch).bind(window);
  var TRUE_XHR = window.__qoubraTrueXHR || window.XMLHttpRequest;

  function isCartAddUrl(url) {
    if (!url) return false;
    var u = typeof url === 'string' ? url : (url.url || '');
    return u.indexOf('/cart/add.js') !== -1 || u.indexOf('/cart/add') !== -1;
  }

  function parseBundlePayload(body) {
    try {
      if (!body) return null;
      if (typeof body === 'string') {
        var parsed = JSON.parse(body);
        if (parsed && Array.isArray(parsed.items) && parsed.items.length > 1) return parsed;
      } else if (body && Array.isArray(body.items) && body.items.length > 1) {
        return body;
      } else if (body instanceof FormData) {
        var entries = Array.from(body.entries());
        var ids = entries.filter(function (e) { return e[0] === 'id' || /items\[\d+\]\[id\]/.test(e[0]); });
        if (ids.length > 1) {
          var items = [];
          var qtys = entries.filter(function (e) { return e[0] === 'quantity' || /items\[\d+\]\[quantity\]/.test(e[0]); });
          ids.forEach(function (e, i) {
            items.push({ id: parseInt(e[1], 10), quantity: qtys[i] ? parseInt(qtys[i][1], 10) : 1 });
          });
          return { items: items };
        }
      }
    } catch (e) {}
    return null;
  }

  function directBundleAdd(payload) {
    return new Promise(function (resolve, reject) {
      var xhr = new TRUE_XHR();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); } catch (e) { resolve(xhr.responseText); }
        } else {
          reject({ status: xhr.status, body: xhr.responseText });
        }
      };
      xhr.onerror = function () { reject({ status: 0, error: 'network' }); };
      xhr.send(JSON.stringify(payload));
    });
  }

  function fetchCart() {
    return new Promise(function (resolve, reject) {
      var xhr = new TRUE_XHR();
      xhr.open('GET', '/cart.js', true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        try { resolve(JSON.parse(xhr.responseText)); } catch (e) { reject(e); }
      };
      xhr.onerror = reject;
      xhr.send();
    });
  }

  function refreshCartUI(cart) {
    var detail = { cart: cart };
    var events = [
      'cart:refresh', 'cart:updated', 'cart:build', 'cart:change',
      'theme:cart:refresh', 'theme:cart:updated',
      'cartly:cart:updated', 'cartly:refresh', 'cartly:cart:refresh',
      'product:added', 'ajaxProduct:added'
    ];
    events.forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
        window.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      } catch (e) {}
    });

    ['Cartly', 'cartly', 'CartDrawer', 'cartDrawer'].forEach(function (key) {
      var obj = window[key];
      if (obj && typeof obj.refresh === 'function') { try { obj.refresh(); } catch (e) {} }
      if (obj && typeof obj.update === 'function') { try { obj.update(cart); } catch (e) {} }
    });

    var qtyEl = document.querySelector('[data-cart-items-qty]');
    if (qtyEl && typeof cart.item_count === 'number') {
      var label = cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');
      qtyEl.textContent = label;
      qtyEl.classList.toggle('hidden', cart.item_count === 0);
    }
  }

  var _wrappedFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var body = init && init.body;

    if (isCartAddUrl(url) && body) {
      var bundlePayload = parseBundlePayload(body);
      if (bundlePayload) {
        return directBundleAdd(bundlePayload).then(function (addResult) {
          fetchCart().then(function (cart) {
            setTimeout(function () { refreshCartUI(cart); }, 80);
          }).catch(function () {});
          return new Response(JSON.stringify(addResult), {
            status: 200,
            statusText: 'OK',
            headers: { 'Content-Type': 'application/json' }
          });
        }).catch(function (err) {
          console.error('[Qoubra] Bundle bypass failed', err);
          return _wrappedFetch.apply(window, arguments);
        });
      }
    }

    return _wrappedFetch.apply(this, arguments);
  };

  var origXHROpen = TRUE_XHR.prototype.open;
  var origXHRSend = TRUE_XHR.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__qoubraUrl = url;
    this.__qoubraMethod = method;
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__qoubraMethod && this.__qoubraMethod.toUpperCase() === 'POST' && isCartAddUrl(this.__qoubraUrl)) {
      var bundlePayload = parseBundlePayload(body);
      if (bundlePayload) {
        var self = this;
        directBundleAdd(bundlePayload).then(function (addResult) {
          var responseText = JSON.stringify(addResult);
          Object.defineProperty(self, 'readyState', { value: 4, configurable: true });
          Object.defineProperty(self, 'status', { value: 200, configurable: true });
          Object.defineProperty(self, 'statusText', { value: 'OK', configurable: true });
          Object.defineProperty(self, 'responseText', { value: responseText, configurable: true });
          Object.defineProperty(self, 'response', { value: responseText, configurable: true });
          if (typeof self.onreadystatechange === 'function') self.onreadystatechange();
          if (typeof self.onload === 'function') self.onload();
          self.dispatchEvent(new Event('readystatechange'));
          self.dispatchEvent(new Event('load'));
          self.dispatchEvent(new Event('loadend'));

          fetchCart().then(function (cart) {
            setTimeout(function () { refreshCartUI(cart); }, 80);
          }).catch(function () {});
        }).catch(function (err) {
          console.error('[Qoubra] XHR bundle bypass failed, falling through', err);
          origXHRSend.call(self, body);
        });
        return;
      }
    }
    return origXHRSend.apply(this, arguments);
  };

  document.addEventListener('katching:bundle:added', function () {
    fetchCart().then(function (cart) { refreshCartUI(cart); }).catch(function () {});
  });

  console.log('[Qoubra] qb-cartly-bundle-fix v2 actif');
})();
